import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  Grid,
  RadioGroup,
  FormControl,
  FormGroup,
} from "@mui/material";
import React from "react";

const Comp12PDF = ({
    formData,
    checked,
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5, borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">しんきんビジネスフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_12_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_12_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_12_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_12_tel}</Box>
            </Box>
            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求先メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            ゴミ・廃材・廃油処理・小間内清掃
            </Typography>
            <FormGroup row>
                <FormControlLabel
                control={<Checkbox name="garbage" checked={checked.garbage} />}
                label="ゴミ処理を希望する"
                />
                <FormControlLabel
                control={<Checkbox name="oil" checked={checked.oil} />}
                label="廃油処理を希望する"
                />
                <FormControlLabel
                control={<Checkbox name="clean" checked={checked.clean} />}
                label="小間内清掃を希望する"
                />
            </FormGroup>

            {checked.garbage && (
            <>
                <Typography variant="subtitle1">ゴミ処理</Typography>
                {[
                { label: "A45L袋ゴミ", value: "A" },
                { label: "B木材系", value: "B" },
                { label: "Cプラスチック系", value: "C" },
                { label: "D鉄くず系", value: "D" },
                { label: "E鉄・プラスチック・木屑など混合物", value: "E" },
                { label: "F陶器・タイル類", value: "F" },
                { label: "G土類", value: "G" },
                ].map((item) => {
                // 選択されてるかどうか
                const selected = formData?.garbage_plan?.find((g) => g.type === item.value);

                return (
                    <Box key={item.value} display="flex" alignItems="center" mb={1}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={!!selected}
                        />
                        }
                        label={item.label}
                    />
                    {selected && (
                        <TextField
                        size="small"
                        placeholder={item.value === "A" ? "袋" : "㎥"}
                        value={selected.amount}
                        Number
                        />
                    )}
                    </Box>
                );
                })}
            </>
            )}


            {checked.oil && (
            <>
                <Typography variant="subtitle1">廃油処理</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">潤滑油引取り作業</FormLabel>
                <RadioGroup
                    row
                    value={formData?.lubricating_oil?.toString()}
                >
                    <FormControlLabel value="true" control={<Radio />} label="希望する" />
                    <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                </RadioGroup>
                </FormControl>

                <FormControl component="fieldset">
                <FormLabel component="legend">廃油引取り作業</FormLabel>
                <RadioGroup
                    row
                    value={formData?.waste_oil?.toString()}
                >
                    <FormControlLabel value="true" control={<Radio />} label="希望する" />
                    <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                </RadioGroup>
                </FormControl>
            </>
            )}

            {checked.clean && (
                <>
                <Typography variant="subtitle1">小間内清掃</Typography>
                <Typography>小間数 ： {formData?.cleanup / (1430 * 3) || 0}</Typography>
                <Typography sx={{ mt: 1 }}>
                清掃料金：{formData?.cleanup} 円（税込）（1430円×小間数×3日間で計算しています。）
                </Typography>
                </>
            )}

            <Typography variant="h6">備考欄</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {formData?.alfa_text}
            </Typography>
        </Box>
        )}
    </Box>
    </Container>
  );
};

export default Comp12PDF;
